import { Link } from 'react-router-dom';
import { roleCanEditCatalog, roleCanManageSettings, roleCanViewAudit } from '@inventohub/shared';
import { useAuth } from '../lib/auth';

export function CatalogPage(): React.JSX.Element {
  const { user } = useAuth();
  const canEdit = user ? roleCanEditCatalog(user.role) : false;
  const canAudit = user ? roleCanViewAudit(user.role) : false;
  const canSettings = user ? roleCanManageSettings(user.role) : false;

  return (
    <section className="card" data-testid="catalog-page">
      <h2>Catalog</h2>
      <p>
        Assets, totes, shop bins, and EWP trailers. Expected tote contents are the assets in that
        tote plus consumable quantities. Equipment admins record official container moves on the
        asset.
      </p>
      {canEdit ? (
        <p className="meta">You can create and edit catalog records, photos, and QR labels.</p>
      ) : (
        <p className="meta">
          You can view the catalog. Only an admin or equipment admin can change it.
        </p>
      )}
      <ul className="link-list">
        <li>
          <Link to="/assets" data-testid="catalog-assets">
            Assets
          </Link>
        </li>
        <li>
          <Link to="/totes" data-testid="catalog-totes">
            Totes
          </Link>
        </li>
        <li>
          <Link to="/bins" data-testid="catalog-bins">
            Bins
          </Link>
        </li>
        <li>
          <Link to="/trailers" data-testid="catalog-trailers">
            EWP trailers
          </Link>
        </li>
        {canEdit ? (
          <li>
            <Link to="/admin/labels" data-testid="catalog-labels">
              QR labels
            </Link>
          </li>
        ) : null}
        {canAudit ? (
          <li>
            <Link to="/admin/audit" data-testid="catalog-audit">
              Audit log
            </Link>
          </li>
        ) : null}
        {canSettings ? (
          <li>
            <Link to="/admin/settings" data-testid="catalog-settings">
              Settings
            </Link>
          </li>
        ) : null}
      </ul>
    </section>
  );
}
